import * as FIELD_NAME from 'constant/form-item-names'
import * as RULES from 'constant/form-rules'
import * as FIELD_LABEL from 'constant/form-labels'
import React from 'react'
import { Form, Select } from 'antd'

const { Option } = Select

const PublishedSelect = () => {
  return (
    <>
      <span>{FIELD_LABEL.PUBLISHED_SELECT}</span>
      <Form.Item
        name={FIELD_NAME.PUBLISHED}
        rules={[RULES.REQUIRED]}
      >
        <Select
          bordered={false}
          placeholder='Publish?'
          size='large'
          style={{ background: '#fff' }}
        >
          <Option value={true}>Published</Option>
          <Option value={false}>Unpublished</Option>
        </Select>
      </Form.Item>
    </>
  )
}

export default PublishedSelect
